import { gspx } from '@rsos/gainsight';
import { readMetaTag } from '@rsos/utils/metaTags';

const feAppName = readMetaTag('fe-app-name');
const CENTRAL_STATION = 'central_station';

const appName = feAppName === CENTRAL_STATION ? 'CSP' : 'RSP';

export const trackCopyAlertLocation = (selectedAlertID, irpVersion) => {
  gspx.trackCustomEvent('Data Location', {
    irpVersion,
    name: `Copy Alert Lat and Long in ${appName}`,
    Category: 'Location Card Copy coordinates',
    'Launched date': new Date(),
    AlertID: selectedAlertID,
  });
};

export const trackCopyAlertAddress = (selectedAlertID, irpVersion) => {
  gspx.trackCustomEvent('Data Location', {
    irpVersion,
    name: `Copy Alert Location address in ${appName}`,
    Category: 'Location Card Copy coordinates',
    'Launched date': new Date(),
    AlertID: selectedAlertID,
  });
};
